import React from 'react'

export const Excellence = (props) => {
  return (
    <>
     <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 73.5 80.63"
    {...props}
  >
    <defs>
    </defs>
    <path
      d="M1 41.45h16.29c2.02 0 3.66 1.64 3.66 3.66v30.86c0 2.02-1.64 3.66-3.66 3.66H1V41.45h0ZM20.95 44.87c3.73-.48 8.91-1.77 14.16-5.15 5.26-3.4 8.42-7.52 10.1-10.11v-7.84c1.1-2.56 3.77-4 6.32-3.52 2.12.4 3.86 2.08 4.42 4.29v10.75c-.03 1.15-.2 2.6-.76 4.16-.49 1.38-1.18 2.55-1.95 3.53"
      className="cls-2"
    />
    <path
      d="M43.95 40.98h24.51c2.67.62 4.4 3.21 3.99 5.81-.39 2.43-2.56 4.29-5.13 4.29H54.31M54.3 51.08h9.98c2.61.44 4.38 2.91 3.99 5.44-.37 2.42-2.61 4.2-5.13 4.02h-7.83"
      className="cls-2"
    />
    <path
      d="M54.84 60.55h5.68c2.61.44 4.38 2.91 3.99 5.44-.37 2.42-2.61 4.2-5.13 4.02h-7.83"
      className="cls-2"
    />
    <path
      d="M52.53 70.03h5.68c2.6.44 4.37 2.9 3.98 5.43-.37 2.42-2.61 4.21-5.12 4.02H30.45a27.835 27.835 0 0 1-9.73-2.22M14.67 56.22v15.63M14.67 49.11v3.74M50.78 1v10.17M64.93 7.63l-6.47 6.47M70.36 22.28h-8.4M35.97 7.95l6.48 6.47M30.54 22.6h8.4"
      className="cls-2"
    />
  </svg>
    </>
  )
}
